import { ToastSize, ToastType } from "../components/toasts/types";
export const newToastMessage = (msg, timeout, type, contrast) => {
    let toastContainerEl = document.querySelector('zpr-toasts[id="toasts"]'); // HTMLZprToastsElement
    if (toastContainerEl === null) {
        toastContainerEl = document.createElement('zpr-toasts');
        toastContainerEl.setAttribute('id', 'toasts');
        document.body.appendChild(toastContainerEl);
    }
    toastContainerEl.addToast(msg, timeout, type, ToastSize.default, contrast);
};
export const newToastSuccessMessage = (msg, timeout, contrast) => {
    newToastMessage(msg, timeout, ToastType.success, contrast);
};
export const newToastErrorMessage = (msg, timeout, contrast) => {
    newToastMessage(msg, timeout, ToastType.error, contrast);
};
export const newToastInfoMessage = (msg, timeout, contrast) => {
    newToastMessage(msg, timeout, ToastType.info, contrast);
};
//# sourceMappingURL=toasts.js.map
